module.exports = __webpack_public_path__ + "static/media/play-1.67b93678.svg";